import { Link } from "react-router-dom";
import SVG from "../../SVG";

const formatNotificationCount = (count) =>
  new Intl.NumberFormat("fa-IR").format(count);

export default function Items({
  svg_name,
  svg_classname = "",
  title,
  isActive = false,
  href = "",
  showTitle = true,
  haveNotifications = false,
  notificationCount = 0,
  onClick = () => {},
}) {
  const safeNotificationCount = Number(notificationCount);
  const notificationText = formatNotificationCount(
    Number.isFinite(safeNotificationCount) ? safeNotificationCount : 0,
  );

  return (
    <Link
      to={href}
      onClick={onClick}
      className={`relative min-w-max p-2 flex items-center gap-5 cursor-pointer hocus:bg-gray-200 dark:hocus:bg-white/5 rounded-lg outline-none ${
        isActive && "bg-zi-gradient-button-blue drop-shadow-md"
      }`}
    >
      <SVG
        name={svg_name}
        classname={`w-5 ${svg_classname} ${
          isActive ? "stroke-white" : "stroke-zi-blue-dark dark:stroke-white"
        }`}
      />
      {showTitle && (
        <p
          className={`text-xs font-light ${
            isActive
              ? "text-white drop-shadow-md"
              : "text-zi-text-light dark:text-zi-text-dark"
          }`}
        >
          {title}
        </p>
      )}
      {haveNotifications && (
        <div className="absolute top-0 right-0 flex min-w-4 h-4 justify-center items-center px-1 rounded-full bg-red-500">
          <span className="text-[10px] font-thin leading-none text-zi-text-dark">
            {notificationText}
          </span>
        </div>
      )}
    </Link>
  );
}
